import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import DeliveryDriverSelect from '../../components/DeliveryDriverSelect/DeliveryDriverSelect';
import Button from '../../components/UI/Button/Button';

class ChangeDriverModal extends Component {
    state = {
        cancel: false,
        closeModal: false
    }

    componentDidUpdate(prevProps) {
        
      }
    

    componentDidMount () {
        this.props.onGetDrivers();

        return;       
    };

    
    driverChanged = (value) => {
        this.props.driverChanged(value);        
    }

    render () {
        if (this.props.drivers.length > 0) {
            return (
                <div>
                <DeliveryDriverSelect driverChanged={this.driverChanged} />
                <Button 
                    btnType="Danger"
                    clicked={this.props.cancelChangeDriver}>CANCEL</Button>
                    </div>
            )        

        }
    }
}


const mapStateToProps = state => {
    return {
        drivers: state.orders.drivers
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetDrivers:() => dispatch(actions.getDrivers())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeDriverModal);


// WEBPACK FOOTER //
// ./src/components/ChangeDriverModal/ChangeDriverModal.js